import { Row, Col, Input, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import PropTypes from 'prop-types';
import ClearIndicator from './ClearIndicator';

function FiltrosActa({
  data,
  isLoading,
  isActa,
  fecha,
  activities,
  setActivities,
  activitiesList,
  isLoadingActivitiesList,
  handleHeadquarter,
  handleCourseYear,
  handleCourse,
  handleType,
  handleGroup,
  handleConvocatoria,
  convocatoria,
  handleFecha,
  parseDateString,
  hideType,
}) {
  if (data === '') return null;

  return (
    <>
      <Row className="mb-3">
        <Col sm>
          <Label for="centros">Centro</Label>
          <Input
            type="select"
            name="centros"
            id="centros"
            onChange={handleHeadquarter}
            disabled={isLoading ? 'disabled' : ''}
          >
            {data.headquarters.map((datos) => (
              <option key={datos} value={datos}>
                {datos}
              </option>
            ))}
          </Input>
        </Col>
        <Col sm className="mt-2 mt-md-0">
          <Label for="grado">Grado</Label>
          <Input
            type="select"
            name="grado"
            id="grado"
            onChange={handleCourse}
            disabled={isLoading ? 'disabled' : ''}
          >
            {data.degree.map((datos) => (
              <option key={datos.value} value={datos.value}>
                {datos.name}
              </option>
            ))}
          </Input>
        </Col>
      </Row>
      <Row className="mt-0 mt-md-2 mb-3">
        <Col sm className="mt-2 mt-md-0">
          <Label for="curso">Curso</Label>
          <Input
            type="select"
            name="curso"
            id="curso"
            onChange={handleCourseYear}
            disabled={isLoading ? 'disabled' : ''}
          >
            {data.years.map((datos) => (
              <option key={datos.value} value={datos.value}>
                {datos.name}
              </option>
            ))}
            <option value="2122">2021/2022</option>
          </Input>
        </Col>
        {!hideType && (
          <Col sm className="mt-2 mt-md-0">
            <Label for="tipo">Tipo</Label>
            <Input
              type="select"
              name="tipo"
              id="tipo"
              onChange={handleType}
              disabled={isLoading ? 'disabled' : ''}
            >
              {data.type.map(
                (datos) =>
                  (isActa || datos.value !== 3) && (
                    <option key={datos.value} value={datos.value}>
                      {datos.name}
                    </option>
                  ),
              )}
            </Input>
          </Col>
        )}
        {hideType && (
          <Col sm className="mt-2 mt-md-0">
            <Label for="grupo">Grupo</Label>
            <Input
              type="select"
              name="grupo"
              id="grupo"
              disabled={isLoading ? 'disabled' : ''}
              onChange={handleGroup}
            >
              {data.groups.length > 0
                ? data.groups.map((datos) => (
                    <option key={datos.titulo} value={datos.titulo}>
                      {datos.titulo}
                    </option>
                  ))
                : ''}
            </Input>
          </Col>
        )}
      </Row>
      {!hideType && (
        <Row className="mt-0 mt-md-2">
          <Col sm className="mt-2 mt-md-0" md={!isActa && 6}>
            <Label for="grupo">Grupo</Label>
            <Input
              type="select"
              name="grupo"
              id="grupo"
              disabled={isLoading ? 'disabled' : ''}
              onChange={handleGroup}
            >
              {data.groups.length > 0
                ? data.groups.map((datos) => (
                    <option key={datos.titulo} value={datos.titulo}>
                      {datos.titulo}
                    </option>
                  ))
                : ''}
            </Input>
          </Col>
          {isActa && (
            <Col sm className="mt-2 mt-md-0">
              <Label for="fecha">Fecha</Label>
              <DatePicker
                id="fecha"
                name="fecha"
                selected={fecha ? parseDateString(fecha, 'dd/MM/yyyy') : null}
                onChange={handleFecha}
                dateFormat="dd/MM/yyyy"
                locale="es"
                className="form-control"
                wrapperClassName="w-100"
              />
              {fecha !== '' ? '' : <span className="text-danger tiny">*Obligatorio</span>}
            </Col>
          )}
        </Row>
      )}
      {hideType && (
        <Row className="mt-0 mt-md-2">
          <Col sm className="mt-2 mt-md-0" md={6}>
            <Label for="convocatoria">Convocatoria</Label>
            <Input
              type="select"
              name="convocatoria"
              id="convocatoria"
              value={convocatoria}
              onChange={handleConvocatoria}
              disabled={isLoading ? 'disabled' : ''}
            >
              <option value="ordinaria">Ordinaria</option>
              <option value="extraordinaria">Extraordinaria</option>
            </Input>
          </Col>
        </Row>
      )}
      {isActa && (
        <Row className="mt-0 mt-md-2">
          <Col sm className="mt-2 mt-md-0" md={6}>
            <Label for="actividades">Actividades</Label>
            <Select
              value={activities}
              closeMenuOnSelect={false}
              options={activitiesList.map((act) => ({ value: act.MP, label: act.MP }))}
              isMulti
              onChange={(selection) => setActivities(selection)}
              components={{ ClearIndicator }}
              placeholder="Seleccionar..."
              disabled={isLoadingActivitiesList}
            />
            {!activities.length && <span className="text-danger tiny">*Obligatorio</span>}
          </Col>
        </Row>
      )}
    </>
  );
}

FiltrosActa.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isLoading: PropTypes.bool.isRequired,
  isActa: PropTypes.bool,
  fecha: PropTypes.string,
  activities: PropTypes.array,
  setActivities: PropTypes.func.isRequired,
  activitiesList: PropTypes.array,
  isLoadingActivitiesList: PropTypes.bool,
  handleHeadquarter: PropTypes.func.isRequired,
  handleCourseYear: PropTypes.func.isRequired,
  handleCourse: PropTypes.func.isRequired,
  handleType: PropTypes.func.isRequired,
  handleGroup: PropTypes.func.isRequired,
  handleConvocatoria: PropTypes.func,
  convocatoria: PropTypes.string,
  handleFecha: PropTypes.func.isRequired,
  parseDateString: PropTypes.func.isRequired,
  hideType: PropTypes.bool,
};

export default FiltrosActa;
